<template>
  <div id="data-list-list-view" class="data-list-container">
    <add-stream
      :isPromptActive="addStreamFormPrompt"
      :callBackAddStream="callBackAddStream"
      @closePrompt="toggleAddStreamFormPrompt"
    />
    <edit-stream
      :isPromptActive="updateStreamFormPrompt"
      :callBackUpdateStream="callBackUpdateStream"
      :entity="streamToUpdate"
      @closePrompt="toggleUpdateStreamFormPrompt"
    />
    <vs-table ref="table" :data="streams">
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <div
            @click="toggleAddStreamFormPrompt(true)"
            class="
              btn-add-new
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Ajouter un stream</span>
          </div>
        </div>
      </div>
      <template slot="thead">
        <vs-th>Nom</vs-th>
        <vs-th>Autheur</vs-th>
        <vs-th>Créer le</vs-th>
        <vs-th width="10%">Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td> {{ tr.name }}</vs-td>
            <vs-td> {{ tr.author }}</vs-td>
            <vs-td> {{ tr.created_at }}</vs-td>
            <vs-td class="whitespace-no-wrap">
              <div class="flex">
                <vx-tooltip text="Modifier le stream">
                  <feather-icon
                    @click="
                      (streamToUpdate = { ...tr }),
                        toggleUpdateStreamFormPrompt(true)
                    "
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
                <vx-tooltip text="Supprimer le stream">
                  <feather-icon @click="deleteStream(tr.slug)"
                    icon="DeleteIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-pagination
      class="mt-1"
      v-if="last_page && page"
      :total="last_page"
      v-model="page"
    ></vs-pagination>
  </div>
</template>

<script>
import { _buildQuery } from "../../../../helpers/buildquery";
import addStream from "./components/addStream.vue";
import editStream from "./components/editStream.vue";

export default {
  components: { addStream, editStream },
  name: "Otd2Streams",

  data() {
    return {
      streams: [],
      search: "",
      page: 1,
      last_page: null,
      streamToUpdate: {},
      addStreamFormPrompt: false,
      updateStreamFormPrompt: false,
    };
  },
  watch: {
    page(value) {
      this.loadStreams(value);
    },
  },

  mounted() {
    this.loadStreams();
  },

  methods: {
    async loadStreams() {
      try {
        this.$vs.loading();
        let params = {
          page: this.page,
          limit: 10,
          search: this.search,
          paginate: '1'
        };
        let response = await this.$http.get(
          "evaluation-streams" + _buildQuery(params)
        );
        if (response.data) {
          this.streams = response.data.data;
          this.last_page = response.data.last_page;
          this.$vs.loading.close();
        }
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Erreur",
          text: error.response.data.message
            ? error.response.data.message
            : "Veuillez contacter l'administrateur",
          color: "danger",
          position: "top-right",
        });
      }
    },
    async deleteStream(slug, index) {
      if (confirm("Souhaitez-vous vraiment supprimer ce stream ?")) {
        try {
          this.$vs.loading();
          let response = await this.$http.post(
            "/evaluation-streams/delete/" + slug
          );
          if (response.data) {
            window.getApp.success("Stream supprimé avec succès", {});
            this.streams.splice(index, 1);
            this.$vs.loading.close();
          }
        } catch (error) {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erreur",
            text: error.response.data.message
              ? error.response.data.message
              : "Veuillez contacter l'administrateur",
            color: "danger",
            position: "top-right",
          });
        }
      }
    },
    callBackAddStream(stream) {
      stream.author = stream.user.lastname + ' ' + stream.user.firstname;
      this.streams.unshift(stream);
    },
    callBackUpdateStream(stream) {
      // console.log(stream);
      this.streams.forEach((element, index) => {
        if (element.id == stream.id) {
          this.streams[index].name = stream.name;
          this.streams[index].slug = stream.slug;
        }
      });
    },
    toggleAddStreamFormPrompt(val = false) {
      this.addStreamFormPrompt = val;
    },
    toggleUpdateStreamFormPrompt(val = false) {
      this.updateStreamFormPrompt = val;
    },
  },
};
</script>

<style lang="scss" scoped>
#data-list-list-view {
  .vs-con-table {
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }
    }

    .vs-table {
      font-size: 0.8rem;
      width: 100% !important;
      border-collapse: separate;
      border-spacing: 0 0.5rem;
      // padding: 0 0.5rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          font-size: 14px;

          &:first-child {
            border-top-left-radius: 0.1rem;
            border-bottom-left-radius: 0.1rem;
          }
          &:last-child {
            border-top-right-radius: 0.1rem;
            border-bottom-right-radius: 0.1rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          // text-transform: uppercase;
          font-weight: 600;
          color: black;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: right;
    }
  }
}
</style>